#import "../fragments/products-for-lead-fragment.graphql"
#import "../../../../shared/graphql/fragments/lead-value-fragment.graphql"

fragment ProductMutationFragment on Lead {
    # Selecting these fields in these mutations will automatically refresh the
    # Apollo cache with the latest data. This will automatically update any
    # components that query any of this data without needing them to refetch.
    id
    ...ProductsForLeadFragment
    ...LeadValueFragment
}
